export default __webpack_public_path__ + "static/media/meet-lagrua-placeholder.a0ebeec8.png";